module.exports = __webpack_public_path__ + "img/legalServices-11.2f54dfd0.png";